import styled from 'styled-components';
import factoryButton from './utils/factoryButton';
import { ButtonFabSC } from './ButtonFab';
const ButtonFabIconSC = styled(ButtonFabSC) `
  min-width: ${(props) => props.theme.SizeWidthButtonIconFloating};

  width: ${(props) => props.theme.SizeWidthButtonIconFloating};
  max-width: ${(props) => props.theme.SizeWidthButtonIconFloating};
  height: ${(props) => props.theme.SizeHeightButtonIconFloating};
  max-height: ${(props) => props.theme.SizeHeightButtonIconFloating};

  padding: 0;
  border-radius: 50%;

  &._ndsBtn--large {
    min-width: ${(props) => props.theme.SizeWidthButtonIconFloatingLarge};
    width: ${(props) => props.theme.SizeWidthButtonIconFloatingLarge};
    max-width: ${(props) => props.theme.SizeWidthButtonIconFloatingLarge};
    height: ${(props) => props.theme.SizeHeightButtonIconFloatingLarge};
    max-height: ${(props) => props.theme.SizeHeightButtonIconFloatingLarge};
    padding: 0;
    border-radius: 50%;
  }

  ::before {
    height: calc(100% + 0.125rem);
    border-radius: 50%;
  }

  &._ndsBtn--large::before {
    border-radius: 50%;
  }

  &._ndsBtn--loading .icon {
    height: ${(props) => props.theme.SizeHeightIconButtonIconBase};
    margin-right: 0;
  }

  &._ndsBtn--loading._ndsBtn--large .icon {
    height: ${(props) => props.theme.SizeHeightIconButtonIconLarge};
    margin-right: 0;
  }
`;
export default factoryButton(ButtonFabIconSC, 'fab-icon');
//# sourceMappingURL=ButtonFabIcon.js.map